import { render, staticRenderFns } from "./accountShare.vue?vue&type=template&id=fac659a0&scoped=true"
import script from "./accountShare.vue?vue&type=script&lang=js"
export * from "./accountShare.vue?vue&type=script&lang=js"
import style0 from "./accountShare.vue?vue&type=style&index=0&id=fac659a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac659a0",
  null
  
)

export default component.exports